var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportDeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192.7 37.2",
    style: {
      enableBackground: "new 0 0 192.7 37.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#054850;}\n\t.st1{fill:#f2e604;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.7,37.2H3c-1.6,0-3-1.4-3-3L5,3c0-1.6,1.4-3,3-3h181.7c1.7,0,3,1.4,3,3l-5,31.2 C187.7,35.8,186.3,37.2,184.7,37.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.4,22.7c-0.4,2.3,2.3,2.7,3.8,2.7c2.1,0,4.4-0.5,4.7-2c0.3-1.2-0.3-1.6-4.7-2.2c-4.8-0.7-7.2-1.2-6.4-4.8 c1-4.5,6.3-5.1,9-5.1c2.4,0,8.3,0.4,7.4,5.4h-4.3c0.2-2.4-2.5-2.6-3.9-2.6c-2.3,0-3.8,1-4,1.8c-0.3,1.3,0.1,1.5,3.9,2.1 c5,0.7,8.3,1.3,7.6,4.9c-0.9,4-5,5.4-9.9,5.4c-3.4,0-8.6-0.7-7.7-5.6L48.4,22.7L48.4,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,11.8h4.1L70,14.1h0.1c1.6-1.9,4.2-2.7,6.6-2.7c6,0,7.7,4.4,6.9,8.4c-0.9,4.1-4.4,8.5-10.5,8.5 c-3.3,0-5.4-1.8-5.5-2.8h-0.1l-1.7,7.2h-4.1L66.4,11.8z M68.7,19.8c-0.6,2.7,0.3,5.3,4.2,5.3c3.9,0,5.9-2.6,6.5-5.3 c0.6-2.6-0.4-5.2-4.2-5.2C71.3,14.5,69.2,17.1,68.7,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,11.2c7.1,0,8.9,4.2,8,8.5c-0.9,4.4-4.5,8.5-11.6,8.5s-8.9-4.2-8-8.5C86.6,15.3,90.2,11.2,97.3,11.2z  M94.3,25c4,0,6.1-2.6,6.6-5.4c0.6-2.7-0.4-5.4-4.4-5.4s-6.1,2.6-6.6,5.4S90.3,25,94.3,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.6,11.8h4.1l-0.7,3.1h0.1c1.5-1.8,3.6-3.5,6.7-3.5c0.6,0,1.1,0.1,1.6,0.1l-0.9,4.1 c-1.1-0.4-1.8-0.4-2.5-0.4c-2.1,0-5.3,1.1-6.1,4.8l-1.6,7.7h-4.1L109.6,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.3,14.8H123l0.6-3h3.3l1-4.9h4.1l-1,4.9h4.3l-0.6,3h-4.3l-1.5,7.2c-0.4,1.8-0.5,2.8,0.9,2.8 c1,0,2,0,3-0.1l-0.6,3c-1.1,0.1-2,0.2-3.2,0.2c-5,0-5-1.8-4.4-4.8L126.3,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.9,23.4h4.7l-0.9,4.2H138L138.9,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.7,27.6h-3.5l0.4-1.9h-0.1c-0.4,0.8-2.9,2.4-5.7,2.4c-5.2,0-6.6-3.8-5.9-7.3c0.7-3.4,3.8-7.2,9-7.2 c2.1,0,4,0.7,4.7,2.3h0.1l1.5-7h3.5L162.7,27.6z M155.2,25.4c3.3,0,5-2.2,5.5-4.5s-0.3-4.5-3.6-4.5s-5.1,2.2-5.6,4.5 C151.1,23.2,151.9,25.4,155.2,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.1,21.7c-0.2,1.5,0.3,3.9,3.8,3.9c2.3,0,3.5-0.8,4.5-2h3.9c-1.1,1.5-3.6,4.5-8.8,4.5 c-6.1,0-7.7-3.6-6.9-7.2c1-4.5,4.9-7.4,9.8-7.4c6,0,7.6,3.7,6.7,7.7l-0.1,0.5H170.1L170.1,21.7z M179.7,19.5 c0.1-2.7-2.1-3.5-3.8-3.5c-1.6,0-4.1,0.8-5.3,3.5H179.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,27.4c0,1-0.8,1.8-1.8,1.8h-23c-1,0-1.8-0.8-1.8-1.8L12,9.9c0-1,0.8-1.8,1.8-1.8h23c1,0,1.8,0.8,1.8,1.8 L36,27.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportDeLogo);
export default __webpack_public_path__ + "static/media/sport_de_logo.5480d3dbab83bf9ec6a8f0fe75d52c88.svg";
export { ForwardRef as ReactComponent };